namespace $.$$ {
	export class $eve_app_page_components_badge extends $.$eve_app_page_components_badge {}
}
